/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ArticleFilterOption {
    ALL = 'All',
    ACTIVE = 'Active',
    INACTIVE = 'Inactive',
}
